@if (teaser) {
    @if (!teaser.showHtmlContents && image) {
        <ds-card
            surface="lowest"
            msThemedCard
            [border]="false"
            [elevated]="true"
            [themeCardElevated]="themeElevated"
            [radius]="!(isMobile() && !isEpcotEnabled())">
            <a [href]="teaser.href" [attr.target]="teaser.target" (click)="trackBannerClicked()">
                <img priority placeholder ngSrcset="1x, 2x, 3x" [height]="169" [width]="540" [ngSrc]="image" />
            </a>
        </ds-card>
    }
    @if (teaser.showHtmlContents && teaser.htmlContents) {
        <div [innerHTML]="teaser.htmlContents | msTrust: 'html'"></div>
    }
}
